import { type GridPosition, type SelectionReducerPolicies } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';

function resolveCellPositionToIdsForCellMode(
  adapter: DatabaseAdapter,
  cell: GridPosition
): { entryId: string | undefined; fieldId: string | undefined } {
  return {
    entryId: adapter.getVisibleEntryIdAt(cell.row.index),
    fieldId: adapter.getVisibleFieldIdAt(cell.col.index),
  };
}

export type CreateDatabaseSelectionReducerPoliciesDeps = {
  canEditContent: () => boolean;
  adapter: DatabaseAdapter;
};

/**
 * Creates the reducer policies for the selections machine.
 */
export function createDatabaseSelectionReducerPolicies(
  deps: CreateDatabaseSelectionReducerPoliciesDeps
): SelectionReducerPolicies {
  return {
    canRequestCellEdit: (cell) => {
      if (!deps.canEditContent()) {
        return false;
      }

      const { entryId, fieldId } = resolveCellPositionToIdsForCellMode(
        deps.adapter,
        cell
      );

      if (!entryId || !fieldId) {
        return false;
      }

      return deps.adapter.canEditValue(fieldId, entryId);
    },

    canClearCells: (_selections) => deps.canEditContent(),
  };
}
